const footer = "_7cfe7v0c3";
const pageContext = "_7cppklb3p";
const pageNumber = "_7cp1d65zpv";
const copyright = "_7ccnwbahj";
const publisherLogo = "_7cp1ikern";

export { copyright, footer, pageContext, pageNumber, publisherLogo };
import "./pm2.footer.style.linaria.module.css";
//# sourceMappingURL=pm2.footer.style.js.map
